import React, { useEffect, useState } from "react";
import { GoChevronLeft } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import OnRampInfo from "../../components/dashboard-components/settings-component/OnRampInfo";
import OffRampInfo from "../../components/dashboard-components/settings-component/OffRampInfo";
import { useLpStore } from "../../store/useLiquidityPartner";
import { useGetLpWallet, useGetStableLp } from "../../sevices/hooks/admin";
export interface ResponseData {
  blockchain: string;
  createdAt: string;
  deletedAt: string | null;
  id: string;
  ramp: "off-ramp" | "on-ramp";
  selected: boolean;
  updatedAt: string;
  walletAddress: string;
  walletType: string;
}
export interface ILP {
  createdAt: string;
  deletedAt: string;
  id: string;
  name: string;
  updatedAt: string;
}

interface ProcessedData {
  offRampArray: ResponseData[];
  onRampArray: ResponseData[];
}

const WalletLayout = () => {
  const lp = useLpStore((state) => state.Lp);
  const selectedLpId = useLpStore((state) => state.selectedLpId);
  console.log(selectedLpId, "selectedLpId");
  // const { data: getAllLp } = useGetStableLp();
  const [currentTab, setCurrentTab] = useState("On-Ramp");
  const setShowWallet = useLpStore((state) => state.setShowWallet);
  const setCurrentRamp = useLpStore((state) => state.setCurrentRamp);
  const navigate = useNavigate();
  const { data: getWallet, isLoading } = useGetLpWallet(selectedLpId);
  const [offRamp, setOffRamp] = useState<ResponseData[]>([]);
  const [onRamp, setOnRamp] = useState<ResponseData[]>([]);

  function processResponseData(data: ResponseData[]): ProcessedData {
    const offRampArray = data.filter((item) => item.ramp === "off-ramp");
    const onRampArray = data.filter((item) => item.ramp === "on-ramp");
    return { offRampArray, onRampArray };
  }

  console.log(getWallet, "getAllLp");

  useEffect(() => {
    const walletData = getWallet?.data?.data;
    console.log(walletData, "walletData");
    if (walletData) {
      const { offRampArray, onRampArray } = processResponseData(walletData);
      setOffRamp(offRampArray);
      setOnRamp(onRampArray);
    }
  }, [getWallet?.data?.data]);

  if (isLoading) {
    return <div>Fetching data..</div>;
  }
  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div
            onClick={() => setShowWallet(false)}
            className="close flex items-center justify-center rounded-full
                hover:bg-slate-200 p-2 hover:rounded-full hover:text-center bg-[#E5F2EA]"
          >
            <span className=" cursor-pointer   hover:transform  transition duration-150 ease-in-out">
              <GoChevronLeft size={20} className="" />
            </span>
          </div>
          <div>
            <p>
              {currentTab} [{currentTab === "On-Ramp" ? `${lp?.name}` : "TTFCX"}{" "}
              Wallet Addresses]
            </p>
            <p className="text-[#676767] text-sm ">
              Select stablecoin liquidity wallet
            </p>
          </div>
        </div>

        <div className="toggle w-60 h-11  flex border border-[#0eb683] mb-6 md:mb-4 self-center justify-between rounded-md cursor-pointer p-1">
          <div
            className={`px-2 flex-1 whitespace-nowrap flex items-center justify-center transition-all duration-500 rounded-sm ${
              currentTab === "On-Ramp" ? "bg-[#0eb683] text-white" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              setCurrentTab("On-Ramp");
              setCurrentRamp("on-ramp");
            }}
          >
            On-Ramp
          </div>
          <div
            className={`px-2 flex-1 whitespace-nowrap flex items-center justify-center transition-all duration-500 rounded-sm ${
              currentTab === "Off-Ramp" ? "bg-[#0eb683] text-white" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              setCurrentTab("Off-Ramp");
              setCurrentRamp("off-ramp");
            }}
          >
            Off-Ramp
          </div>
        </div>
      </div>

      <div>
        {currentTab === "On-Ramp" ? (
          <div className="mt-10 w-full">
            <OnRampInfo onRampData={onRamp} />
          </div>
        ) : (
          <div className="mt-10 w-full">
            <OffRampInfo offRampData={offRamp} />
          </div>
        )}
      </div>
    </div>
  );
};

export default WalletLayout;
